<template>
    <v-container class="padding-top-0 padding-bootom-0 pl-0">
        <v-row dense>
            <v-col cols="12" class="padding-top-0">
                <v-card>
                    <v-card-text class="pt-1 pb-0">
                        <template>
                            <v-row>
                                <v-col cols="5">
                                    <v-select 
                                        :items="filter_options" 
                                        label="Buscar Por"
                                        clearable
                                        hide-details
                                        clear-icon="far fa-times-circle"
                                        @change="handleChangeFilter">
                                    </v-select>
                                </v-col>

                                <v-col cols="7">
                                    <v-autocomplete
                                        v-if="filter_type == 'Estado'"
                                        v-model="value_status"
                                        :items="status"
                                        dense
                                        clearable 
                                        clear-icon="far fa-times-circle"             
                                        label="Estado de pedido"
                                        persistent-hint
                                        item-value="text"
                                        hide-details
                                        @change="handleSelecteBuyer"
                                    >
                                    </v-autocomplete>

                                    <v-autocomplete
                                        v-if="filter_type == 'Cliente'"
                                        v-model="value_customer"
                                        :items="customers"
                                        dense
                                        clearable 
                                        clear-icon="far fa-times-circle"               
                                        label="Clientes"
                                        persistent-hint
                                        :item-text="customText"
                                        item-value="id"
                                        hide-details
                                        @change="handleSelecteCustomer"
                                        :filter="customFilter"
                                    >
                                        <template v-slot:item="data">
                                            <v-list-item-content>
                                                <v-list-item-title v-if="data.item.type_document === 'DNI' ">{{ data.item.name }} {{ data.item.surname }}</v-list-item-title>
                                                <v-list-item-title v-else>{{ data.item.name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ data.item.type_document }}: {{ data.item.document }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </v-autocomplete>

                                    <v-autocomplete
                                    v-if="filter_type == 'Repartidor'"
                                        :items="deliveryUsers"
                                        dense
                                        clearable 
                                        clear-icon="far fa-times-circle"               
                                        label="Repartidores"
                                        persistent-hint
                                        :item-text="customTextDelivery"
                                        item-value="id"
                                        hide-details
                                        @change="handleSelectDeliveryMan">
                                        <template v-slot:item="data">
                                            <v-list-item-content class="pt-1 pb-1">
                                                <v-list-item-title>{{ data.item.fullname }}</v-list-item-title>
                                            </v-list-item-content>                                    
                                        </template>
                                    </v-autocomplete>

                                </v-col>
                                
                                <v-col cols="1" class="pl-0" v-if="show_icons">
                                    <v-btn color="primary" icon @click="handleShowHideFilter">
                                        <v-icon>{{ icon_filter }}</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="1" class="pl-0 d-none d-sm-flex" v-if="show_icons">
                                    <v-btn color="primary" icon @click="handleLintToNewSale">
                                        <v-icon>fas fa-plus</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>
                        
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" class="mt-2 mb-2 customer-list wost-scroll">
                <v-card v-for="order in ordersFounded" :key="order.id" class="mt-3 " 
                    @click="handleClickOrder(order)" 
                    active-class="customer-selected"
                    :disabled="!verifyPermission('seleccionar_pedido_venta')">
                    <v-card-text class="padding-all-0">
                        <v-list two-line dense class="padding-top-0 padding-bootom-0 ">
                            <v-list-item>
                                <v-list-item-avatar class="mr-2">
                                    <v-icon class="blue lighten-1 white--text" v-if="order.customer.type_document === 'DNI'">fas fa-user-tie</v-icon>
                                    <v-icon v-else class="blue lighten-1 white--text">fas fa-building</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span class="order-customer-name" v-if="order.customer.type_document === 'DNI'">
                                            {{ order.customer.name }} {{ order.customer.surname }}
                                        </span>
                                        <span class="order-customer-name" v-else>
                                            {{ order.customer.name }}
                                        </span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <span :class="'order-status order-status-' + order.status.toLowerCase().replace(' ', '-')">
                                            <v-icon size="8" :class="'mr-1 order-status-' + order.status.toLowerCase().replace(' ', '-')">fas fa-circle</v-icon> {{ order.status | uppercase }}
                                        </span>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <span class="order-block order-total">
                                        {{ order.total | currency('S/ ') }}
                                    </span>
                                    <span class="order-block">
                                        #{{ order.id | numberOrder }}
                                    </span>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-card-text>                    
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import router from '@/router/index'
import Tools from '../../helpers/Tools.js'

export default {
    name: 'Customers',
    data() {
        return {
            user: null,
            is_delivery_man: false,
            value: '',
            value_customer: '',
            value_status: '',
            customer_filter: false,
            status_filter: true,
            icon_customer: 'fas fa-user-tag',
            icon_status: 'fas fa-th-list',
            icon_filter: 'fas fa-user-tag',
            show_icons: false,
            filter_options: ['Cliente', 'Repartidor', 'Estado'],
            filter_type: null
        }
    },
    computed: {
        ...mapState('orders', [
            'orders',
            'status',
            'ordersFounded',
            'order',
            'customers',
            'history',
            'deliveryUsers'
        ]),
    },
    methods: {
        ...mapActions('orders', [
            'getOrders',
            'getOrderStatusDropDown',
            'searchOrders',
            'selectOrder',
            'getAvailableStatus',
            'assignDeliveryman',
            'assignFinalDeliveryman',
            'getDeliveryUsers',
            'getCustomers',
            'getHistory',
            'getDebtCustomer'
        ]),
        ...mapMutations('orders', [
            'setOrders',
            'setStatus'
        ]),
        handleSelecteBuyer(event) {
            if(event === undefined) {
                this.getListOrders() 
            } else{
                let type = 'status'
                let query = event            
                this.searchOrders({type, query})
            }            
        },
        handleClickOrder(order){
            this.selectOrder(null)
            this.getDeliveryUsers()
            this.selectOrder(order)
            this.getAvailableStatus()
            this.assignDeliveryman(-1)
            this.assignFinalDeliveryman(-1)
            if (order.deliveryman !== null) {
                this.assignDeliveryman(order.deliveryman)
            }
            if(order.final_deliveryman !== null) {
                this.assignFinalDeliveryman(order.final_deliveryman)
            }
            let params = {
                option: 'customer',
                customer_id: order.customer_id
            }
            this.getHistory(params)
            this.getDebtCustomer(order.customer_id)
        },
        handleLintToNewSale(){
            router.push('/sales')
        },
        handleSelecteCustomer(value){
            if(value === undefined) {
                this.getListOrders() 
            } else{
                let type = 'customer'
                let query = value            
                this.searchOrders({type, query})
            }
        },
        handleShowHideFilter(){
            this.value_customer = ''
            this.value_status = ''
            this.customer_filter = !this.customer_filter
            this.status_filter = !this.status_filter
            if(this.customer_filter){
                this.icon_filter = this.icon_status
            }
            if(this.status_filter){
                this.icon_filter = this.icon_customer
            }
            this.getOrders()
        },
        customText(item){
            let text = item.name
            if (item.type_document === 'DNI') {
                text = item.name + ' ' + item.surname
            }
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();             
            }
            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();             
            }
            let searchText = queryText.toLowerCase()


            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleChangeFilter(value){
            this.filter_type = null            
            if(value !== undefined && value !== null){
                this.filter_type = value
            }
        },
        getListOrders() {
            this.is_delivery_man = this.$isDeliveryMan()
            if (this.is_delivery_man) {
                this.user = this.$identifiedUser()
                let params = {
                    user_id: this.user.id
                }
                this.getOrders(params)
            } else {
                this.getOrders()
            }
        },
        customTextDelivery(item){
            let text = item.fullname
            return text
        },
        handleSelectDeliveryMan(value){
            if(value === undefined) {
                this.getListOrders() 
            } else{
                let type = 'deliveryman'
                let query = value            
                this.searchOrders({type, query})
            }
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getCustomers()
        this.getOrderStatusDropDown()
        this.getListOrders()
        this.selectOrder(null)
    }
}
</script>

<style scope>

.customer-selected{
    background-color: #3949AB !important;
}

.customer-list{
    height: 63vh;
    overflow-y: auto;
}

.order-customer{
    /*border-radius: 15px !important;*/
}

.order-block{
    display: block;
}

.order-customer-name{
    font-weight: bold;
    color: #1E1E1F;
    cursor: pointer;
}

.order-total{
    font-weight: bold;
    color: #1E1E1F;
}

.order-status{
    font-weight: bold;
    font-size: .7rem;
}

.order-icon{
    padding-top: 10px !important;
}

</style>